import { Container, Row, Col } from "react-bootstrap";
// New package button
import { Button } from '@veeyaainnovatives/button';
import { useNavigate } from "react-router-dom";

const ServiceNotFound = () => {
  const navigate = useNavigate();

  return (
    <Container className="py-5">
      <Row className="justify-content-center text-center">
        <Col lg={6}>
          <div className="mb-4">
            <i
              className="fa-solid fa-circle-exclamation"
              style={{ fontSize: "64px", color: "#dc3545" }}
            />
          </div>

          <h2 className="fw-bold mb-3">Service Not Found</h2>

          <p className="text-muted mb-4">
            The service you are looking for doesn’t exist or may have been moved.
            Please check the URL or explore our available services.
          </p>

          <div className="d-flex justify-content-center gap-3 flex-wrap">
           
            <Button 
              className="home-button"
              backgroundColor="#677a58"
              color="#ffffff"
              hoverBackgroundColor="#5a6a4a"
              padding="13px 40px"
              fontSize="16px"
              fontWeight="500"
              borderRadius="100px"
              onClick={() => navigate("/")}
            >
              Go to Home
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ServiceNotFound;
